import { useContext } from 'react';
import { WorkspaceContext } from '../context/WorkspaceContext';
import { useDatabaseEntity } from './useDatabaseEntity';

export interface TeamDetails {
  id: string;
  name: string;
  memberIds: string[];
  subTeamIds: string[];
}

export function useTeam(teamId: string | undefined) {
  const { safeData } = useContext(WorkspaceContext);
  const { entity, loading, error } = useDatabaseEntity<TeamDetails>(teamId, {
    entityType: 'Team',
    deps: [safeData],
    build: async (database, id) => {
      const obj = database.teams()[id];
      if (!obj) return null;
      const base: TeamDetails = {
        id,
        name: obj.name(),
        memberIds: [],
        subTeamIds: [],
      };
      if (!safeData) return base;
      try {
        const [memberIds, subTeamIds] = await Promise.all([
          obj.member_person_ids(safeData, false),
          obj.member_team_ids(safeData),
        ]);
        return { ...base, memberIds, subTeamIds };
      } catch (err) {
        console.error('Error fetching team members:', err);
        return base;
      }
    },
  });
  return { team: entity, loading, error };
}
